import { all, takeEvery, put, call } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import * as actionTypes from "../../actionLabels";
import * as actionsBidHistory from "../../actions";
import CustomToast from "../../../components/Toast";

function* fetchAuctionBidHistoryData(action) {
  try {
    const response = yield call(
      axiosMain.post,
      `/report/bharatAuctionBidHistoryReport`,
      action.payload
    );

    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        if (1 == action.payload.isExport || 2 == action.payload.isExport) {
          yield put(
            actionsBidHistory.fetchAuctionBidHistoryDataExportSuccess(
              response.data
            )
          );
        } else {
          yield put(
            actionsBidHistory.fetchAuctionBidHistoryDataSuccess(response.data)
          );
        }

        yield put(actionsBidHistory.fetchAuctionBidHistoryDataApiCall(true));
      } else {
        CustomToast.error(response.data.message);
        yield put(
          actionsBidHistory.fetchAuctionBidHistoryDataFailure(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(
        actionsBidHistory.fetchAuctionBidHistoryDataFailure(
          response.data.message
        )
      );
    }
  } catch (error) {
    yield put(actionsBidHistory.fetchAuctionBidHistoryDataFailure(error));
  }
}

function* fetchAuctionBidHistoryLotWiseData(action) {
  try {
    const response = yield call(
      axiosMain.post,
      `/report/bharatAuctionBidHistoryLotWiseReport`,
      action.payload
    );

    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        yield put(
          actionsBidHistory.fetchAuctionBidHistoryLotWiseDataSuccess(
            response.data
          )
        );

        yield put(
          actionsBidHistory.fetchAuctionBidHistoryLotWiseDataApiCall(true)
        );
      } else {
        CustomToast.error(response.data.message);
        yield put(
          actionsBidHistory.fetchAuctionBidHistoryLotWiseDataFailure(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(
        actionsBidHistory.fetchAuctionBidHistoryLotWiseDataFailure(
          response.data.message
        )
      );
    }
  } catch (error) {
    yield put(
      actionsBidHistory.fetchAuctionBidHistoryLotWiseDataFailure(error)
    );
  }
}

function* fetchSearchDropDownForAuctionBidHistory(action) {
  try {
    const response = yield call(
      axiosMain.post,
      `/report/bharatAuctionBidHistoryReportSearchDropDown`,
      action.payload
    );

    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        yield put(
          actionsBidHistory.fetchSearchDropDownForAuctionBidHistorySuccess(
            response.data
          )
        );
      } else {
        // CustomToast.error(response.data.message);
        yield put(
          actionsBidHistory.fetchSearchDropDownForAuctionBidHistoryFailure(
            response.data.message
          )
        );
      }
    } else {
      // CustomToast.error(response.data.message);
      yield put(
        actionsBidHistory.fetchSearchDropDownForAuctionBidHistoryFailure(
          response.data.message
        )
      );
    }
  } catch (error) {
    yield put(
      actionsBidHistory.fetchSearchDropDownForAuctionBidHistoryFailure(error)
    );
  }
}

export function* auctionBidHistoryReportSagas() {
  yield takeEvery(
    actionTypes.FETCH_AUCTION_BID_HISTORY_DATA,
    fetchAuctionBidHistoryData
  );

  yield takeEvery(
    actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA,
    fetchAuctionBidHistoryLotWiseData
  );

  yield takeEvery(
    actionTypes.FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY,
    fetchSearchDropDownForAuctionBidHistory
  );
}
